import Axios from "./Axios";
import { getAnalyticsBaseUrl } from "../constants";

const baseUrl = getAnalyticsBaseUrl();
const subUrl = "https%3A%2F%2Fkinema.link%2Fpage%2F";

export const getDynamicLinksAnalytics = async (
  link: string,
  duration = 365
) => {
  const getLink = link.replaceAll("https://kinema.link/page/", "");
  const url = `${baseUrl}${subUrl}${getLink}`;
  const data = {
    durationDays: duration,
  };
  return Axios("GET", url, data);
};
